<template lang="html">
  <div class="wrapper">
    
  </div>
</template>

<script>
import {
    mapState,
    mapActions,
    mapMutations
  } from "vuex";
  
export default {
  name: 'AdminOrder',
  components: {
  },
  data() {
    return {
      password: '',
      loading: false,
    };
  },
  methods: {
    ...mapActions(['fnApiSetAdminOrder']),
    getToken(){
      return this.$route.query.t
    }

  },

  beforeCreate() {},
  created() {
    if(this.$route.query.t){
      this.$store.state.viewStore = false;
      this.fnApiSetAdminOrder(this.$route.query.t);
    }else{
      this.$store.state.viewStore = true;
      this.$router.push('/');
    }
  },
  mounted() {},
  beforeDestroy() {},

};
</script>